import { createSelector } from '@ngrx/store';

import { getAuthState, IAuthState } from '@apps/auth/store/auth.reducer';

import { AuthUsersFeatureKey, IAuthUsersState, usersAdapter } from './users.state';
import { ShortProfile } from '@apps/auth/domain/models';

const getAuthUsersState = createSelector(
    getAuthState,
    (state: IAuthState) =>
        state[AuthUsersFeatureKey]
);
const getAuthUsersCollection = createSelector(
    getAuthUsersState,
    (state: IAuthUsersState) => state.users
);
export const {
    selectAll: getAllUsers
} = usersAdapter.getSelectors(getAuthUsersCollection);



export const getShortProfile = (userName: string) => createSelector(
    getAllUsers,
    (users: ShortProfile[]): ShortProfile =>
    {
        const un = userName.toUpperCase();

        return users.find((user: ShortProfile): boolean =>
            user.userName === un
        );
    }
);
